module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_3_1.a56a7faa.png";